/* eslint-disable react/prop-types */
import classNames from 'classnames';
import FileListItem from 'components/custom/ui/FileListItem';
import React, { useEffect, useState } from 'react';
import { formatDate } from 'services/utils';

const EmployeeDetailsAttachments = ({ data }) => {
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    let { Aadhar, PAN, Passport } =
      data?.identification_details?.reduce((acc, i) => {
        return {
          ...acc,
          [i.document_type]: i
        };
      }, {}) || {};

    if (data?.identification_details) {
      const updatedAttachments = [
        {
          name: 'Passport Image',
          mimeType: 'image',
          size: '768kb',
          user: Passport?.document_identification_number || '',
          date:
            `Exp : ${formatDate(Passport?.document_expiry_date, 'DD MMM YYYY') || ''}` ||
            '',
          thumbnail: Passport?.front_image || '',
          show: Passport?.front_image ? 'true' : 'false'
        },
        {
          name: 'Aadhaar Front Image',
          mimeType: 'image',
          size: '768kb',
          user: Aadhar?.document_identification_number || '',
          date: '',
          thumbnail: Aadhar?.front_image || '',
          show: Aadhar?.front_image ? 'true' : 'false'
        },
        {
          name: 'Aadhaar Back Image',
          mimeType: 'image',
          size: '130 kb',
          user: Aadhar?.document_identification_number || '',
          date: '',
          thumbnail: Aadhar?.back_image || '',
          show: Aadhar?.back_image ? 'true' : 'false'
        },
        {
          name: 'Pan Card Image',
          mimeType: 'image',
          size: '123 kb',
          user: PAN?.document_identification_number || '',
          date: '',
          thumbnail: PAN?.front_image || '',
          show: PAN?.front_image ? 'true' : 'false'
        }
      ];

      // Filter out objects where show is 'false'
      const filteredAttachments = updatedAttachments.filter(
        attachment => attachment.show === 'true'
      );

      setAttachments(filteredAttachments);
    }
  }, [data]);

  return (
    <>
      <h2 className="mb-4">Attachments</h2>
      <div>
        {attachments.map((attachment, index) => (
          <FileListItem
            key={attachment.name}
            attachment={attachment}
            className={classNames('border-dashed', {
              'border-top': index === 0,
              'border-bottom-0': index === attachments.length - 1
            })}
          />
        ))}
      </div>
    </>
  );
};

export default EmployeeDetailsAttachments;
